import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';

const BoilerSwitch = styled(Switch)(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    display: 'flex',
    '&:active .MuiSwitch-thumb': {
        width: 22,
    },
    '& .MuiSwitch-switchBase': {
        padding: 2,
        '&.Mui-checked': {
            transform: 'translateX(16px)',
            color: theme.palette.common.white,
            '& + .MuiSwitch-track': {
                backgroundColor: theme.palette.success.main,
                opacity: 1,
            },
        },
        '& + .MuiSwitch-track': {
            backgroundColor: theme.palette.error.main,
            opacity: 1,
        },
    },
    '& .MuiSwitch-thumb': {
        backgroundColor: theme.palette.common.white,
        width: 22,
        height: 22,
        borderRadius: 11,
        boxShadow: '0 1px 3px rgba(0,0,0,0.3)',
    },
    '& .MuiSwitch-track': {
        borderRadius: 13,
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
            duration: 300,
        }),
    },
}));

export default BoilerSwitch;
